import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import styled from "styled-components";
import * as Typos from "src/components/atoms/Typographs";
import routes from "src/constants/routes";
import { Btn, CheckboxWrapper } from "src/theme/Styled";
import { ADD_WISH_ITEM_BUTTON } from "src/theme/Labels";
import { Status } from "src/config";
import { Submit } from "src/components/atoms/Buttons";
import wishService from "src/services/wish.service";
import { useDispatch } from "react-redux";
import ACTIONS from "src/redux/actions";
import Images from "src/theme/Images";

const CreatePopup = (props) => {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm();
  const [image, setImage] = useState("");
  const [wishItem, setWishItem] = useState({});
  const [submitStatus, setSubmitStatus] = useState(Status.NONE);
  const addItem = (data) => {
    setSubmitStatus(Status.REQUEST);
    const result = { ...wishItem, ...data };
    delete result._id;
    delete result["purchased"];
    delete result["received"];
    delete result["purchaser"];
    const form = new FormData();
    for (const key in result) {
      form.append(key, result[key]);
    }
    wishService
      .createWish(form)
      .then((data) => {
        dispatch({
          type: ACTIONS.USER.CREATE_WISHITEM,
          payload: data,
        });
        setSubmitStatus(Status.SUCCESS);
      })
      .catch((err) => {
        setSubmitStatus(Status.FAILURE);
      });
  };

  const goToWishList = () => {
    navigate("/wish-list");
  };

  useEffect(() => {
    for (const key in props.item) {
      if (props.item[key]) {
        setValue(key, props.item[key]);
      }
    }
    props.item?.thumbnail && setImage(props.item?.thumbnail);
    setWishItem({ ...props.item });
  }, []);
  return (
    <>
      {submitStatus === Status.SUCCESS ? (
        <div className="p-3">
          <div>
            <CS.Thumb className={(image ? "has-image" : "") + " success-image"}>
              {image ? (
                <img
                  src={image}
                  alt="wish item thumbnail"
                  className="wish-item-thumbnail"
                />
              ) : (
                <img
                  src={Images.plusIcon}
                  className="browse-image"
                  alt="browse"
                />
              )}
            </CS.Thumb>
          </div>
          <Typos.PageTitle className="text-center mb-0 mt-3">
            Added To Your Wish List
          </Typos.PageTitle>
          <Btn onClick={goToWishList} className="mx-auto px-5 mt-3">
            VIEW WISH LIST
          </Btn>
        </div>
      ) : (
        <div className="pb-3">
          <Typos.PageTitle className="text-center mt-4">
            Add To Wish List
          </Typos.PageTitle>
          <CS.Form>
            <div>
              <CS.Thumb className={image ? "has-image" : ""}>
                {image ? (
                  <img
                    src={image}
                    alt="wish item thumbnail"
                    className="wish-item-thumbnail"
                  />
                ) : (
                  <img
                    src={Images.plusIcon}
                    className="browse-image"
                    alt="browse"
                  />
                )}
              </CS.Thumb>
            </div>
            <form onSubmit={handleSubmit(addItem)}>
              <div className="mb-2">
                <Typos.FLabel>*Name of Item</Typos.FLabel>
                <input
                  type="text"
                  {...register("name", {
                    required: {
                      value: true,
                      message: "Name of item is required",
                    },
                  })}
                  className={errors.name ? "has-error" : ""}
                />
                {errors.name ? (
                  <Typos.Error>{errors.name.message}</Typos.Error>
                ) : null}
              </div>
              <div className="inline-form-groups">
                <div className="mb-2">
                  <Typos.FLabel>Price</Typos.FLabel>
                  <div className="position-relative">
                    <span className="form-prefix-icon">$</span>
                    <input type="text" {...register("price")} />
                  </div>
                </div>
                <div className="mb-2">
                  <Typos.FLabel>Size</Typos.FLabel>
                  <input type="text" {...register("size")} />
                </div>
                <div className="mb-2">
                  <Typos.FLabel>Quantity</Typos.FLabel>
                  <input type="text" {...register("quantity")} />
                </div>
              </div>
              <div className="inline-form-groups2">
                <div className="mb-2 color-value">
                  <Typos.FLabel>Color/Type</Typos.FLabel>
                  <input type="text" {...register("color_flavor")} />
                </div>
                <div className="mb-2 favorite-value">
                  <CheckboxWrapper className="with-label form-checkbox">
                    <input type="checkbox" {...register("favorite")} />
                    <Typos.FLabel>Favorite</Typos.FLabel>
                  </CheckboxWrapper>
                </div>
              </div>
              <Submit
                className="mt-2"
                title={ADD_WISH_ITEM_BUTTON}
                status={submitStatus}
              />
            </form>
          </CS.Form>
        </div>
      )}
    </>
  );
};

const CS = {
  Form: styled.div`
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 16px;

        @media screen and (max-width: 768px) {
            display: block;
        }

        form {
            .inline-form-groups {
                display: grid;
                grid-template-columns repeat(3, 1fr);
                grid-column-gap: 8px;
                & > div {
                    grid-column: span 1;
                }
            }
            .inline-form-groups2 {
              display: grid;
              grid-template-columns auto 90px;
              grid-column-gap: 8px;
            }
        }
    `,

  Thumb: styled.div`
    height: 100%;
    max-height: 255px;
    border: 1px solid #919191;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s;
    overflow: hidden;

    &.has-image {
      border-color: white;
    }

    &:hover {
      border-color: black !important;
    }

    .browse-image {
      width: 30px;
      height: 30px;
    }
    .wish-item-thumbnail {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }

    @media screen and (max-width: 768px) {
      height: 240px;
    }

    &.success-image {
      border-color: transparent !important;
      width: 250px;
      height: 210px;
      margin: auto;
    }
  `,
};

export default CreatePopup;
